import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumberFormat'
})
export class CustomNumberFormatPipe implements PipeTransform {
  transform(value: number | string, fractionDigits: number = 2, minimumFractionDigits: number | null = null): string {

    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    if (isNaN(value)) {
      return '';
    }

    if (Number.isInteger(value)) {
      return new Intl.NumberFormat('en-US').format(value); // Format as a whole number
    }

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : fractionDigits,
      maximumFractionDigits: fractionDigits
    }).format(value);
  }
}
